module.exports = __webpack_public_path__ + "LOGO.svg?903096af325398a79d8698344aa81dcb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LOGO.svg
// module id = 273
// module chunks = 0